export const DivisionSizes = {
	"0-10"	:	{
		title	:	"0-10"
	},
	"10-50"	:	{
		title	:	"10-50"
	},
	"50-100"	:	{
		title	:	"50-100"
	},
	"100-500"	:	{
		title	:	"100-500"
	},
	"500-1000"	:	{
		title	:	"500-1000"
	},
	"1000-2000"	:	{
		title	:	"1000-2000"
	},
	"2000-5000"	:	{
		title	:	"2000-5000"
	},
	"+5000"		:	{
		title	:	"+5000"
	}
};